import { CPicker } from './CPicker.js';

const CPickerPlugin = {
    install: (app) => {
        app.component(CPicker.name, CPicker);
    },
};

export { CPicker, CPickerPlugin };
//# sourceMappingURL=index.js.map
